import { FileUploadWidget } from './FileUploadWidget';
import {
  ServiceAgreementV2,
  ServiceRole,
  StepMetadata,
  ConfigurationServiceRoleMetadata,
} from 'pco-product-service-internal-consumer';
import { StepMetadataType } from 'types';

export /**
 *
 *
 * @param {*} formData
 * @return {*}
 */
const getAction = (formData: Record<string, unknown>) => {
  const action = formData[FORM_DATA_DECISION_KEY] as string;
  return actionMap[action as keyof typeof actionMap];
};

export const getStepMetadata = (
  serviceAgreement: ServiceAgreementV2 | ServiceRole | null | undefined,
  stepMetadataType: StepMetadata['stepMetadataType'],
) => {
  const stepMetadata = serviceAgreement?.stepMetadata || [];
  if (stepMetadata.length === 0) {
    return;
  }

  return stepMetadata
    .filter((x) => x !== undefined) // Avoid NPE caused by wrong response from BE
    .find((x) => x.stepMetadataType === stepMetadataType);
};

export const getServiceRoleDefinition = (serviceAgreement: ServiceAgreementV2, serviceRoleDefinitionName: string) => {
  const stepMetadataServiceRole = getStepMetadata(
    serviceAgreement,
    StepMetadataType.CONFIGURATION_SERVICE_ROLE_METADATA,
  );
  if (stepMetadataServiceRole === undefined) {
    return;
  }

  return (stepMetadataServiceRole as ConfigurationServiceRoleMetadata)?.serviceRoleList?.filter(
    (sR) => sR.name === serviceRoleDefinitionName,
  )[0];
};

export const getServiceRoleStepMetadata = (
  serviceAgreement: ServiceAgreementV2,
): ConfigurationServiceRoleMetadata | undefined => {
  return getStepMetadata(serviceAgreement, StepMetadataType.CONFIGURATION_SERVICE_ROLE_METADATA) as
    | ConfigurationServiceRoleMetadata
    | undefined;
};

export enum ActionOutcome {
  APPROVED = 'approved',
  REJECTED = 'rejected',
  REQUEST_CLARIFICATION = 'request clarification',
}

export const actionMap = {
  Confirm: ActionOutcome.APPROVED,
  Recommended: ActionOutcome.APPROVED,
  'Resubmit for approval': ActionOutcome.APPROVED,
  'Broker approved': ActionOutcome.APPROVED,
  Approve: ActionOutcome.APPROVED,
  'Approvals received': ActionOutcome.APPROVED,
  'Approval not required': ActionOutcome.APPROVED,
  Approved: ActionOutcome.APPROVED,
  'Not recommended': ActionOutcome.REJECTED,
  'Withdraw request': ActionOutcome.REJECTED,
  'Broker rejected': ActionOutcome.REJECTED,
  'Delete delegate': ActionOutcome.REJECTED,
  Reject: ActionOutcome.REJECTED,
  Rejected: ActionOutcome.REJECTED,
  'Approval rejected': ActionOutcome.REJECTED,
  'Request clarification': ActionOutcome.REQUEST_CLARIFICATION,
  'Request clarifications': ActionOutcome.REQUEST_CLARIFICATION,
  'I confirm that the conditions are met': ActionOutcome.APPROVED,
  'Cancel product opening': ActionOutcome.REJECTED,
};

const FORM_DATA_DECISION_KEY = 'decision';

export const uiSchema = {
  serviceRole: {
    'ui:widget': 'hidden',
  },
  title: '',
  'ui:date': 'customWidget',
  Comment: {
    'ui:widget': 'textarea',
  },
  file: {
    'ui:widget': FileUploadWidget,
  },
};
